<div class="bdo-container">
    <h4>{{ 'register.account.activationTitle' | translate }}</h4>
    <div class="bdo-tile">
      <div class="bdo-loading__wrapper bdo-loading__wrapper--height">
        <bdo-loading></bdo-loading>
      </div>
      <p class="re-text-center">{{ 'register.account.activationInProgress' | translate }}</p>
    </div>
</div>
